import { CartRow } from 'gung-standard';

export function getAddonsByParentProduct(
  cartRows: CartRow[]
): { addonsKeys: string[]; addonsIds: string[]; parentProductId: string }[] {
  // get all info under configure
  return cartRows
    .filter(row => row.extra.configure && row.extra.configure)
    .map(row => {
      const addonByParentProduct = {
        addonsKeys: [],
        addonsIds: [],
        parentProductId: row.productId
      };

      // go through all the row entries in configure and get only the ones which contain a value
      // if the value is falsy then that entry is to be cleared
      for (const addonKey of Object.keys(row.extra.configure)) {
        if (row.extra.configure[addonKey]) {
          addonByParentProduct.addonsKeys.push(addonKey);
          addonByParentProduct.addonsIds.push(row.extra.configure[addonKey]);
        }
      }

      return addonByParentProduct;
    })
    .filter(items => items.addonsIds.length > 0); // unsure that we only have entries which contain at least one value (addonId)
}

export function flattenArray(array: any[][]): any[] {
  return array.reduce((a, b) => a.concat(b), []);
}
